export enum TextClassificationRoutingBehavior {
  Suggested = 'Suggested',
  Automatic = 'Automatic',
}
